module.exports = __webpack_public_path__ + "img/mode2-7.b5d94d1b.png";